<template>
  <div class="content" style="padding: 0px; font-size: 12px">
    <!-- <div class="content-header bg-light" slot="content-header">
      <div class="pd-x-0 pd-y-0">
        <ul class="nav nav-pills">
          <li class="nav-item mg-r-5">
            <div class="tx-12 text-muted">Хугацаа</div>
            <date-picker
              class="wd-100p"
              size="mini"
              v-model="filter.date"
              type="daterange"
              range-separator="To"
              start-placeholder="Эхлэх огноо"
              end-placeholder="Дуусах огноо"
            ></date-picker>
          </li>
          <li class="nav-item mg-r-5">
            <div class="tx-12 text-muted">Тоног төхөөрөмж</div>
            <loc-type-cascader
              v-model="filter.typeCur"
              :disableAdd="true"
              locTypekey="assetDBType"
              size="mini"
              :checkStrictly="true"
            />
          </li>
          <li class="nav-item mg-r-5">
            <div class="tx-12 text-muted">Төрөл</div>
            <loc-type-cascader
              v-model="filter.categoryCur"
              :disableAdd="true"
              locTypekey="delayType"
              size="mini"
            />
          </li>
          <li class="nav-item mg-r-5">
            <div class="tx-12 text-muted">Төлөв</div>
            <loc-type-cascader
              v-model="filter.onlineStatusId"
              :disableAdd="true"
              locTypekey="assetState"
              size="mini"
            />
          </li>
          <li class="nav-item mg-r-5">
            <div class="tx-12 text-muted">Дуудлага бүртгэсэн</div>
            <hrm-select v-model="filter.hrmCreated" />
          </li>
          <li class="nav-item mg-r-5">
            <div class="tx-12 text-muted">Засварлаж буй</div>
            <hrm-select v-model="filter.hrmPinned" />
          </li>
          <li class="nav-item mg-r-5">
            <div class="tx-12 text-muted">Байршлаар шүүх</div>
            <loc-type-cascader
              v-model="filter.locationCur"
              :disableAdd="true"
              locTypekey="assetLocation"
              size="mini"
              :checkStrictly="true"
            />
          </li>
          <li class="nav-item">
            <div class="btn-group btn-xs mg-l-20">
              <button @click="chart1()" class="btn btn-white">Шүүх</button>
              <button @click="filterReset()" class="btn btn-secondary">
                Бүгд
              </button>
            </div>
          </li>
        </ul>
      </div>
    </div> -->
    <div class="content-body" style="height: calc(100vh - 60px)">
      <!-- <div class="container pd-x-0 pd-lg-x-10 pd-xl-x-0"> -->
      <div class="">
        <div
          class="
            d-sm-flex
            align-items-center
            justify-content-between
            mg-b-20 mg-lg-b-30
          "
        >
          <div>
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb breadcrumb-style1 mg-b-10">
                <li class="breadcrumb-item">
                  <a href="#">Удирдлага</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  Хөдөлгөөн зохицуулалт
                </li>
              </ol>
            </nav>
            <h4 class="mg-b-0 tx-spacing--1">Тавтай морилно уу</h4>
          </div>
          <div class="d-none d-md-block">
            <!-- <button
              @click="editShow(0)"
              class="btn btn-sm pd-x-15 btn-primary btn-uppercase"
            >
              <feather type="plus" class="wd-10 mg-r-5"></feather>Шинэ дуудлага
            </button> -->

            <button
              @click="eeljChooserModal.show = true"
              class="btn btn-sm pd-x-15 btn-info btn-uppercase mg-l-10"
            >
              <feather type="edit" class="wd-10 mg-r-5"></feather>
              <span
                v-if="
                  eeljChooserModal.data.types.length > 0 &&
                  eeljChooserModal.data.typeId != null
                "
              >
                <!-- {{eeljChooserModal.data.typeId}}
                {{eeljChooserModal.data.types.filter(x=>x.id == eeljChooserModal.data.typeId)[0]}} -->
                {{
                  eeljChooserModal.data.types.filter(
                    (x) => x.id == eeljChooserModal.data.typeId
                  )[0].title
                }}
              </span>
              <span v-else>Ээлж солих</span>
            </button>
          </div>
        </div>

        <div
          class="row row-xs"
          v-if="chart1Obj.rdy && hasPermission(['assetdashboardhzbh'])"
        >
          <div class="col-sm-4 col-lg-2">
            <div class="card card-body">
              <h6
                class="
                  tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold
                  mg-b-8
                "
              >
                Хэвийн
              </h6>
              <div class="d-flex d-lg-block d-xl-flex align-items-end">
                <h3 class="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">
                  {{ chart1Obj.flat.siteData.count }}/{{
                    chart1Obj.flat.siteData.count -
                    chart1Obj.flat.callData.count
                  }}
                </h3>
                <p class="tx-11 tx-color-03 mg-b-0">
                  <span class="tx-medium tx-success"
                    >{{
                      (
                        ((chart1Obj.flat.siteData.count -
                          chart1Obj.flat.callData.count) *
                          100) /
                        chart1Obj.flat.siteData.count
                      ).toFixed(2)
                    }}%</span
                  >
                </p>
              </div>
            </div>
          </div>
          <div class="col-sm-4 col-lg-10 mg-t-10 mg-sm-t-0">
            <div
              class="d-flex justify-content-between"
              v-if="chart1Obj.flat.callsByReason.length > 0"
            >
              <div
                class="card pd-x-10 card-body"
                v-for="(s, i) in chart1Obj.flat.callsByReason"
                :key="i"
                :style="{ 'background-color': s.color }"
                :class="{ 'mg-l-10': i > 0 }"
                role="button"
                :title="s.name"
                @click="
                  $router.push({
                    name: 'cmmsCalls',
                    params: {
                      ot: 507,
                      edit: 0,
                      detail: 0,
                      locTypeId: s.id,
                      isTender: 0,
                      currentColumnId: 0,
                      isCompleted: false,
                      task1_ltId3: 0,
                      task2_ltId: 0,
                    },
                  })
                "
              >
                <h6
                  class="
                    tx-uppercase tx-11 tx-spacing-1 tx-white tx-semibold
                    mg-b-8
                  "
                >
                  <!-- {{s}} -->
                  {{ s.name }}
                </h6>
                <div class="d-flex d-lg-block d-xl-flex align-items-end">
                  <h3 class="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1 tx-white">
                    {{ s.count }}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="row row-xs"
          v-if="chart1Obj.rdy && hasPermission(['assetdashboardmttah'])"
        >
          <div class="col-sm-4 col-lg-2">
            <div class="card card-body">
              <h6
                class="
                  tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold
                  mg-b-8
                "
              >
                Хэвийн
              </h6>
              <div class="d-flex d-lg-block d-xl-flex align-items-end">
                <h3 class="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">
                  {{ chart1Obj.flat.siteData.count }}/{{
                    chart1Obj.flat.siteData.count -
                    chart1Obj.flat.callData.count
                  }}
                </h3>
                <p class="tx-11 tx-color-03 mg-b-0">
                  <span class="tx-medium tx-success"
                    >{{
                      (
                        ((chart1Obj.flat.siteData.count -
                          chart1Obj.flat.callData.count) *
                          100) /
                        chart1Obj.flat.siteData.count
                      ).toFixed(2)
                    }}%</span
                  >
                </p>
              </div>
            </div>
          </div>
          <div class="col-sm-4 col-lg-10 mg-t-10 mg-sm-t-0">
            <div class="d-flex justify-content-between">
              <div
                class="card pd-x-10 card-body"
                :style="{ 'background-color': '#FFC000' }"
                title="Шинэ дуудлага"
                role="button"
                @click="
                  $router.push({
                    name: 'cmmsCalls',
                    params: {
                      ot: 507,
                      edit: 0,
                      detail: 0,
                      locTypeId: 0,
                      isTender: false,
                      currentColumnId: 33737,
                      isCompleted: false,
                      task1_ltId3: 0,
                      task2_ltId: 0,
                    },
                  })
                "
              >
                <h6
                  class="
                    tx-uppercase tx-11 tx-spacing-1 tx-white tx-semibold
                    mg-b-8
                  "
                >
                  Шинэ дуудлага
                </h6>
                <div class="d-flex d-lg-block d-xl-flex align-items-end">
                  <h3 class="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1 tx-white">
                    {{ chart1Obj.flat.callData.workNotCreatedCallCount }}
                  </h3>
                  <!-- /Хуваарилагдаагүй/ -->
                </div>
              </div>
              <div
                class="card pd-x-10 card-body mg-l-10"
                v-for="(s, i) in chart1Obj.flat.workOrderData.inColumn"
                :key="i"
                :style="{ 'background-color': s.column.color }"
                :title="s.column.name"
                role="button"
                @click="
                  $router.push({
                    name: 'cmmsWorkOrders',
                    params: {
                      ot: 508,
                      edit: 0,
                      detail: 0,
                      currentColumnId: s.column.id,
                      locTypeId: 0,
                      locTypeId1: 0,
                      isCompleted: false,
                      task1_ltId3: 0,
                      task2_ltId: 0,
                    },
                  })
                "
              >
                <h6
                  class="
                    tx-uppercase tx-11 tx-spacing-1 tx-white tx-semibold
                    mg-b-8
                  "
                >
                  {{ s.column.shortName }}
                </h6>
                <div class="d-flex d-lg-block d-xl-flex align-items-end">
                  <h3 class="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1 tx-white">
                    {{ s.count }}
                  </h3>
                </div>
              </div>

              <!-- <div
                class="card pd-x-10 card-body mg-l-10"
                :style="{ 'background-color': 'rgb(255 145 41)' }"
                title="Хугацаа дөхсөн"
                
                @click="showTicketsByDueDate(1)"
                role="button"
                v-if="chart1Obj.rdy && hasPermission(['assetdashboardmttah']) &&
                  chart1Obj.flat.workOrderData.notCompletedWorkOrders.filter(
                    (x) => x.perc > 70 && x.perc < 100
                  ).length > 0
                "
              >
                <h6
                  class="
                    tx-uppercase tx-11 tx-spacing-1 tx-white tx-semibold
                    mg-b-8
                  "
                >
                  Хугацаа дөхсөн
                </h6>
                <div class="d-flex d-lg-block d-xl-flex align-items-end">
                  <h3 class="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1 tx-white">
                    {{
                      chart1Obj.flat.workOrderData.notCompletedWorkOrders.filter(
                        (x) => x.perc > 70 && x.perc < 100
                      ).length
                    }}
                  </h3>
                </div>
              </div> -->
              <div
                class="card pd-x-10 card-body mg-l-10"
                :style="{ 'background-color': 'rgb(223 45 45)' }"
                title="Урт хугацаатай"
                @click="showTicketsByDueDate(2)"
                role="button"
                v-if="
                  chart1Obj.flat.workOrderData.notCompletedWorkOrders.filter(
                    (x) => x.perc >= 100
                  ).length > 0
                "
              >
                <h6
                  class="
                    tx-uppercase tx-11 tx-spacing-1 tx-white tx-semibold
                    mg-b-8
                  "
                >
                  Урт хугацаатай
                </h6>
                <div class="d-flex d-lg-block d-xl-flex align-items-end">
                  <h3 class="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1 tx-white">
                    <!-- {{ chart1Obj.flat.callData.workNotCreatedCallCount }} -->
                    {{
                      chart1Obj.flat.workOrderData.notCompletedWorkOrders.filter(
                        (x) => x.perc >= 100
                      ).length
                    }}
                  </h3>
                  <!-- /Хуваарилагдаагүй/ -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row row-xs">
          <div class="col-4">
            <div class="card">
              <div class="card-body">
                <h5 class="card-title">Серверийн өрөөний температур</h5>
                <!-- {{serverTemp.name}} {{serverTemp.ip}}, {{serverTemp.macaddr}}-->
                <h6 class="card-subtitle mb-2 text-muted">
                  Шинэчилсэн: {{ serverTempLastUpdated }}
                </h6>

                <table class="table tabl-bordered table-striped mg-b-0-f">
                  <thead>
                    <th>Мэдрэгч</th>
                    <th>Яг одоо</th>
                    <th>Бага</th>
                    <th>Их</th>
                    <!-- <th>type</th>
                <th>enabled</th>
                    <th>alarm</th>-->
                  </thead>
                  <tbody>
                    <tr v-for="(s, i) in serverTemp.sensor" :key="i">
                      <td>{{ s.label }}</td>
                      <td>{{ s.tempc }}</td>
                      <td>{{ s.lowc }}</td>
                      <td>{{ s.highc }}</td>
                      <!-- <td>{{s.type}}</td>
                  <td>{{s.enabled}}</td>
                      <td>{{s.alarm}}</td>-->
                    </tr>
                  </tbody>
                </table>
                <!-- <h6 > Шинэчилсэн: </h6> -->
              </div>
            </div>
            <div class="card mg-t-10">
              <div class="card-header pd-b-0 pd-x-20 bd-b-0">
                <h6 class="mg-b-0">Онцгой болон дотуур холбооны дуудлага</h6>
              </div>
              <div class="card-body pd-t-25">
                <!-- {{ specialCallData }} -->
                <table class="table tabl-bordered table-striped mg-b-0-f">
                  <thead>
                    <th>Төрөл</th>
                    <th>Тоо</th>
                  </thead>
                  <tbody v-if="specialCallDataRdy">
                    <tr v-for="(call, i) in specialCallData" :key="i">
                      <td>{{ call.type }}</td>
                      <td>{{ call.count }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="card mg-t-10 bd-0" v-if="chart1Obj.rdy">
              <table class="table table-bordered">
                <thead>
                  <!-- <tr>
                    <th scope="col" colspan="6">
                      <h6 class="pd-5 mg-b-0">Тоног төхөөрөмж</h6>
                    </th>
                  </tr> -->
                  <tr>
                    <th>
                      <h6 class="pd-5 mg-b-0">Тоног төхөөрөмж</h6>
                    </th>
                    <th>
                      <h6 class="pd-5 mg-b-0">Нийт</h6>
                    </th>
                    <th>
                      <h6 class="pd-5 mg-b-0" title="Дуудлага">Ду</h6>
                    </th>
                    <th>
                      <h6 class="pd-5 mg-b-0" title="Засвар">За</h6>
                    </th>
                    <th>
                      <h6 class="pd-5 mg-b-0" title="Хэвийн">Хэв</h6>
                    </th>
                    <th>
                      <h6 class="pd-5 mg-b-0">Хувь</h6>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(a, i) in chart1Obj.flat.asset.groupedByType"
                    :key="i"
                  >
                    <td>{{ a.typeName }}</td>
                    <td class="text-right">{{ a.count }}</td>
                    <td
                      class="text-right"
                      @click="
                        $router.push({
                          name: 'cmmsCalls',
                          params: {
                            ot: 507,
                            edit: 0,
                            detail: 0,
                            locTypeId: 0,
                            isTender: 0,
                            currentColumnId: 0,
                            isCompleted: false,
                            task1_ltId3: a.siteTypeId,
                            task2_ltId: a.typeId,
                          },
                        })
                      "
                      role="button"
                    >
                      <a href="javascript:void(0)">
                        {{ a.callCount }}
                      </a>
                    </td>
                    <td
                      class="text-right"
                      @click="
                        $router.push({
                          name: 'cmmsWorkOrders',
                          params: {
                            ot: 508,
                            edit: 0,
                            detail: 0,
                            currentColumnId: 0,
                            locTypeId: 0,
                            locTypeId1: 0,
                            isCompleted: false,
                            task1_ltId3: a.siteTypeId,
                            task2_ltId: a.typeId,
                          },
                        })
                      "
                      role="button"
                    >
                      <a href="javascript:void(0)">
                        {{ a.workCount }}
                      </a>
                    </td>
                    <td class="text-right">
                      {{ a.count - a.callCount - a.noCallWorkCount }}
                    </td>
                    <td class="text-right">
                      {{
                        (
                          ((a.count - a.callCount - a.noCallWorkCount) * 100) /
                          a.count
                        ).toFixed(1)
                      }}%
                    </td>
                  </tr>
                  <tr class="font-weight-bold text-success">
                    <td>Нийт Гэрлэн дохио</td>
                    <td class="text-right">{{chart1Obj.flat.asset.groupedByType.filter(x=>x.typeId == 76131).reduce(
                      (sum, { count }) => sum + parseInt(count),
                      0
                    )}} </td>
                    <td  @click="
                        $router.push({
                          name: 'cmmsCalls',
                          params: {
                            ot: 507,
                            edit: 0,
                            detail: 0,
                            locTypeId: 0,
                            isTender: 0,
                            currentColumnId: 0,
                            isCompleted: false,
                            task1_ltId3: 0,
                            task2_ltId: 76131,
                          },
                        })
                      "
                      role="button" class="text-right">{{chart1Obj.flat.asset.groupedByType.filter(x=>x.typeId == 76131).reduce(
                      (sum, { callCount }) => sum + parseInt(callCount),
                      0
                    )}}</td>
                    <td class="text-right">
                      <a role="button" @click="
                        $router.push({
                          name: 'cmmsWorkOrders',
                          params: {
                            ot: 508,
                            edit: 0,
                            detail: 0,
                            currentColumnId: 0,
                            locTypeId: 0,
                            locTypeId1: 0,
                            isCompleted: false,
                            task1_ltId3: 0,
                            task2_ltId: 76131,
                          },
                        })
                      ">
                      {{chart1Obj.flat.asset.groupedByType.filter(x=>x.typeId == 76131).reduce(
                      (sum, { workCount }) => sum + parseInt(workCount),
                      0
                    )}}</a></td>
                    <td class="text-right">{{chart1Obj.flat.asset.groupedByType.filter(x=>x.typeId == 76131).reduce(
                      (sum, { count , callCount , noCallWorkCount }) => sum + parseInt(count - callCount - noCallWorkCount),
                      0
                    )}}</td>
                    <td class="text-right">-</td>
                  </tr>
                  <tr class="font-weight-bold text-info">
                    <td>Нийт Хяналтын камер /CCTV/</td>
                    <td class="text-right">{{chart1Obj.flat.asset.groupedByType.filter(x=>x.typeId == 76460).reduce(
                      (sum, { count }) => sum + parseInt(count),
                      0
                    )}} </td>
                    <td class="text-right"  @click="
                        $router.push({
                          name: 'cmmsCalls',
                          params: {
                            ot: 507,
                            edit: 0,
                            detail: 0,
                            locTypeId: 0,
                            isTender: 0,
                            currentColumnId: 0,
                            isCompleted: false,
                            task1_ltId3: 0,
                            task2_ltId: 76460,
                          },
                        })
                      "
                      role="button">{{chart1Obj.flat.asset.groupedByType.filter(x=>x.typeId == 76460).reduce(
                      (sum, { callCount }) => sum + parseInt(callCount),
                      0
                    )}}</td>
                    <td class="text-right"><a role="button" @click="
                        $router.push({
                          name: 'cmmsWorkOrders',
                          params: {
                            ot: 508,
                            edit: 0,
                            detail: 0,
                            currentColumnId: 0,
                            locTypeId: 0,
                            locTypeId1: 0,
                            isCompleted: false,
                            task1_ltId3: 0,
                            task2_ltId: 76460,
                          },
                        })
                      ">{{chart1Obj.flat.asset.groupedByType.filter(x=>x.typeId == 76460).reduce(
                      (sum, { workCount }) => sum + parseInt(workCount),
                      0
                    )}}</a></td>
                    <td class="text-right">{{chart1Obj.flat.asset.groupedByType.filter(x=>x.typeId == 76460).reduce(
                      (sum, { count , callCount , noCallWorkCount }) => sum + parseInt(count - callCount - noCallWorkCount),
                      0
                    )}}</td>
                    <td class="text-right">-</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <table
              v-if="chart1Obj.rdy && chart1Obj.flat.biylelt.length > 0"
              class="
                table table-striped
                mg-t-20
                table-bordered table-sm table-responsive
              "
            >
              <thead>
                <tr>
                  <th class="font-weight-bold" style="min-width: 220px">
                    Гэмтэл саатлын засварын биелэлт
                  </th>
                  <th
                    v-for="(s, i) in chart1Obj.flat.biylelt[0].stat"
                    :key="i"
                    :title="s.name"
                    style="
                      min-width: 60px;
                      max-width: 60px;
                      line-height: 1.2;
                      overflow: hidden;
                      padding: 0 5px 10px;
                      margin: 0;
                    "
                    class="tx-12 text-center"
                  >
                    {{ s.shortName }}
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(b, i) in chart1Obj.flat.biylelt" :key="i">
                  <td>{{ b.name }}</td>
                  <td
                    :title="s.name"
                    v-for="(s, si) in b.stat"
                    :key="si"
                    :style="`color: ${s.color}`"
                    class="font-weight-bold text-right"
                  >
                    {{ s.count }}
                  </td>
                  <td class="text-right"></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-8">
            <div class="card mg-t-10">
              <div class="d-flex">
                <div
                  class="wd-50p btn-group"
                  role="group"
                  aria-label="Basic example"
                >
                <button
                    type="button"
                    @click="searchByWorkAndCall('call')"
                    class="btn btn-purple"
                  >
                    Дуудлага
                  </button>
                  <button
                    type="button"
                    @click="searchByWorkAndCall('work')"
                    class="btn btn-danger"
                  >
                    Засвар арчлалт
                  </button>

                  <button
                    type="button"
                    @click="searchBySitePrefix('tcs', true)"
                    class="btn btn-warning"
                  >
                    Гэрлэн дохио
                  </button>
                  <button
                    type="button"
                    @click="searchBySitePrefix('cctv', true)"
                    class="btn btn-info"
                  >
                    CCTV
                  </button>
                  <button
                    type="button"
                    @click="searchBySitePrefix(null)"
                    class="btn btn-secondary"
                  >
                    Бүгд
                  </button>
                </div>
                <div class="wd-50p input-group">
                  <input
                    type="text"
                    v-model="filter.sitePrefix"
                    v-on:keyup="checkEnter"
                    class="form-control"
                    placeholder="Код бичнэ үү"
                    aria-label="Код бичнэ үү"
                    aria-describedby="button-addon2"
                  />
                  <div class="input-group-append">
                    <button
                      class="btn btn-outline-light"
                      @click="
                        filter.sitePrefixContain = false;
                        chart1();
                      "
                      type="button"
                      id="button-addon2"
                    >
                      хайх
                    </button>
                  </div>
                </div>
              </div>

              <GmapMap
                :center="{ lat: 47.9138932, lng: 106.8986408 }"
                :zoom="12"
                map-type-id="roadmap"
                labels="off"
                style="width: 100%; height: 65vh"
                ref="map"
              >
                <!-- <GmapCluster> -->
                <GmapInfoWindow
                  :options="infoOptions"
                  :position="infoWindowPos"
                  :opened="infoWinOpen"
                  @closeclick="infoWinOpen = false"
                ></GmapInfoWindow>
                <GmapMarker
                  style="color: green"
                  :icon="`${myResBaseUrl}apps/asset/${m.icon}.png?w=24`"
                  @click="toggleInfoWindow(m, i)"
                  v-for="(m, i) in googleMapMaker"
                  :key="i"
                  :position="m.position"
                  :title="m.title"
                />
              </GmapMap>
            </div>
          </div>

          <div class="col-lg-8">
            <!-- <div class="card">
              <div
                class="
                  card-header
                  d-sm-flex
                  justify-content-between
                  bd-b-0
                  pd-t-20 pd-b-0
                "
              >
                <div class="mg-b-10 mg-sm-b-0">
                  <h6 class="mg-b-5">Одоогийн дуудлагын төлөв</h6>
                  <p class="tx-12 tx-color-03 mg-b-0">
                    as of 10th to 17th of March 2019
                  </p>
                </div>
                <ul
                  class="
                    list-inline
                    tx-uppercase tx-10 tx-medium tx-spacing-1 tx-color-03
                    mg-b-0
                  "
                >
                  <li class="list-inline-item">
                    <span
                      class="
                        d-inline-block
                        wd-7
                        ht-7
                        bg-gray-400
                        rounded-circle
                        mg-r-5
                      "
                    ></span>
                    Шинэ
                    <span class="d-none d-md-inline">дуудлагууд</span>
                  </li>
                  <li class="list-inline-item mg-l-10">
                    <span
                      class="
                        d-inline-block
                        wd-7
                        ht-7
                        bg-df-2
                        rounded-circle
                        mg-r-5
                      "
                    ></span>
                    Шийдвэрлэсэн
                    <span class="d-none d-md-inline">дуудлагууд</span>
                  </li>
                  <li class="list-inline-item mg-l-10">
                    <span
                      class="
                        d-inline-block
                        wd-7
                        ht-7
                        bg-primary
                        rounded-circle
                        mg-r-5
                      "
                    ></span>
                    Нээлттай
                    <span class="d-none d-md-inline">дуудлагууд</span>
                  </li>
                </ul>
              </div>
              <div class="card-body">
                <div class="chart-fifteen">
                  <apexcharts
                    v-if="chart1Obj.rdy"
                    type="line"
                    :options="chart1Obj.option"
                    :series="chart1Obj.series"
                  ></apexcharts>
                </div>
              </div>
              <div class="card-footer pd-y-15 pd-x-20" v-if="chart1Obj.rdy">
                <div class="row row-sm">
                  <div class="col-6 col-sm-4 col-md-3 col-lg">
                    <h4 class="tx-normal tx-rubik mg-b-10">
                      <span title="өнөөдөр" style="cursor: help">{{
                        chart1Obj.flat.newTicket.today
                      }}</span>
                      /
                      <span title="нийт" style="cursor: help">{{
                        chart1Obj.flat.newTicket.all
                      }}</span>
                    </h4>
                    <div class="progress ht-2 mg-b-10">
                      <div
                        class="progress-bar wd-100p bg-df-2"
                        role="progressbar"
                        aria-valuenow="100"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                    <h6
                      class="
                        tx-uppercase tx-spacing-1 tx-semibold tx-10 tx-color-02
                        mg-b-2
                      "
                    >
                      Шинэ
                    </h6>
                    <p class="tx-10 tx-color-03 mg-b-0">
                      <span
                        :class="`tx-medium ${
                          chart1Obj.flat.newTicket.today >
                          chart1Obj.flat.newTicket.yesterday
                            ? 'tx-success'
                            : 'tx-danger'
                        }`"
                      >
                        {{
                          (
                            (chart1Obj.flat.newTicket.today * 100) /
                            chart1Obj.flat.newTicket.yesterday
                          ).toFixed(1)
                        }}%
                        <i
                          :class="`icon ion-md-arrow-${
                            chart1Obj.flat.newTicket.today >
                            chart1Obj.flat.newTicket.yesterday
                              ? 'up'
                              : 'down'
                          }`"
                        ></i>
                      </span>
                      өчигдрөөс
                    </p>
                  </div>
                  <div class="col-6 col-sm-4 col-md-3 col-lg">
                    <h4 class="tx-normal tx-rubik mg-b-10">
                      {{ chart1Obj.flat.solved.today }} /
                      {{ chart1Obj.flat.solved.all }}
                    </h4>
                    <div class="progress ht-2 mg-b-10">
                      <div
                        class="progress-bar wd-100p bg-df-2"
                        role="progressbar"
                        aria-valuenow="100"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                    <h6
                      class="
                        tx-uppercase tx-spacing-1 tx-semibold tx-10 tx-color-02
                        mg-b-2
                      "
                    >
                      Шийдвэрлэсэн
                    </h6>
                    <p class="tx-10 tx-color-03 mg-b-0">
                      <span
                        :class="`tx-medium ${
                          chart1Obj.flat.solved.today >
                          chart1Obj.flat.solved.yesterday
                            ? 'tx-success'
                            : 'tx-danger'
                        }`"
                      >
                        {{
                          (
                            (chart1Obj.flat.solved.today * 100) /
                            chart1Obj.flat.solved.yesterday
                          ).toFixed(1)
                        }}%
                        <i
                          :class="`icon ion-md-arrow-${
                            chart1Obj.flat.solved.today >
                            chart1Obj.flat.solved.yesterday
                              ? 'up'
                              : 'down'
                          }`"
                        ></i>
                      </span>
                      өчигдрөөс
                    </p>
                  </div>
                  <div class="col-6 col-sm-4 col-md-3 col-lg">
                    <h4 class="tx-normal tx-rubik mg-b-10">
                      {{ chart1Obj.flat.unresolved.today }} /
                      {{ chart1Obj.flat.unresolved.all }}
                    </h4>
                    <div class="progress ht-2 mg-b-10">
                      <div
                        class="progress-bar wd-100p bg-df-2"
                        role="progressbar"
                        aria-valuenow="100"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                    <h6
                      class="
                        tx-uppercase tx-spacing-1 tx-semibold tx-10 tx-color-02
                        mg-b-2
                      "
                    >
                      Шийдвэрлээгүй
                    </h6>
                    <p class="tx-10 tx-color-03 mg-b-0">
                      <span
                        :class="`tx-medium ${
                          chart1Obj.flat.unresolved.today >
                          chart1Obj.flat.unresolved.yesterday
                            ? 'tx-success'
                            : 'tx-danger'
                        }`"
                      >
                        {{
                          (
                            (chart1Obj.flat.unresolved.today * 100) /
                            chart1Obj.flat.unresolved.yesterday
                          ).toFixed(1)
                        }}%
                        <i
                          :class="`icon ion-md-arrow-${
                            chart1Obj.flat.unresolved.today >
                            chart1Obj.flat.unresolved.yesterday
                              ? 'up'
                              : 'down'
                          }`"
                        ></i>
                      </span>
                      өчигдрөөс
                    </p>
                  </div>
                  <div class="col-6 col-sm-4 col-md-3 col-lg">
                    <h4 class="tx-normal tx-rubik mg-b-10">
                      {{ chart1Obj.flat.openTicket.today }} /
                      {{ chart1Obj.flat.openTicket.all }}
                    </h4>
                    <div class="progress ht-2 mg-b-10">
                      <div
                        class="progress-bar wd-100p bg-df-2"
                        role="progressbar"
                        aria-valuenow="100"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                    <h6
                      class="
                        tx-uppercase tx-spacing-1 tx-semibold tx-10 tx-color-02
                        mg-b-2
                      "
                    >
                      Нээлттэй
                    </h6>
                    <p class="tx-10 tx-color-03 mg-b-0">
                      <span
                        :class="`tx-medium ${
                          chart1Obj.flat.openTicket.today >
                          chart1Obj.flat.openTicket.yesterday
                            ? 'tx-success'
                            : 'tx-danger'
                        }`"
                      >
                        {{
                          (
                            (chart1Obj.flat.openTicket.today * 100) /
                            chart1Obj.flat.openTicket.yesterday
                          ).toFixed(1)
                        }}%
                        <i
                          :class="`icon ion-md-arrow-${
                            chart1Obj.flat.openTicket.today >
                            chart1Obj.flat.openTicket.yesterday
                              ? 'up'
                              : 'down'
                          }`"
                        ></i>
                      </span>
                      өчигдрөөс
                    </p>
                  </div>
                  <div class="col-6 col-sm-4 col-md-3 col-lg">
                    <h4 class="tx-normal tx-rubik mg-b-10">
                      {{ chart1Obj.flat.unassigned.today }} /
                      {{ chart1Obj.flat.unassigned.all }}
                    </h4>
                    <div class="progress ht-2 mg-b-10">
                      <div
                        class="progress-bar wd-100p bg-df-2"
                        role="progressbar"
                        aria-valuenow="100"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                    <h6
                      class="
                        tx-uppercase tx-spacing-1 tx-semibold tx-10 tx-color-02
                        mg-b-2
                      "
                    >
                      Хувиарлаагүй
                    </h6>
                    <p class="tx-10 tx-color-03 mg-b-0">
                      <span
                        :class="`tx-medium ${
                          chart1Obj.flat.unassigned.today >
                          chart1Obj.flat.unassigned.yesterday
                            ? 'tx-success'
                            : 'tx-danger'
                        }`"
                      >
                        {{
                          (
                            (chart1Obj.flat.unassigned.today * 100) /
                            chart1Obj.flat.unassigned.yesterday
                          ).toFixed(1)
                        }}%
                        <i
                          :class="`icon ion-md-arrow-${
                            chart1Obj.flat.unassigned.today >
                            chart1Obj.flat.unassigned.yesterday
                              ? 'up'
                              : 'down'
                          }`"
                        ></i>
                      </span>
                      өчигдрөөс
                    </p>
                  </div>
                </div>
              </div>
            </div> -->

            <div class="row row-xs">
              <!-- <div class="col-md-6">
                <div class="card">
                  <div class="card-header pd-b-0 pd-t-20 bd-b-0">
                    <h6 class="mg-b-0">Төрлөөр</h6>
                  </div>
                  <div class="card-body">
                    <div class="chart-seventeen">
                      <apexcharts
                        v-if="chart1Obj.rdy"
                        :options="{
                          chart: { type: 'bar', height: 350 },
                          plotOptions: { bar: { horizontal: true } },
                          dataLabels: { enabled: false },
                          xaxis: {
                            categories: chart1Obj.flat.requestByType.list.map(
                              (x) => {
                                return x.type;
                              }
                            ),
                          },
                        }"
                        :series="[
                          {
                            data: chart1Obj.flat.requestByType.list.map((x) => {
                              return x.count;
                            }),
                          },
                        ]"
                      ></apexcharts>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card">
                  <div class="card-header pd-b-0 pd-t-20 bd-b-0">
                    <h6 class="mg-b-0">Байршлаар</h6>
                  </div>
                  <div class="card-body">
                    <div class="chart-seventeen">
                      <apexcharts
                        v-if="chart1Obj.rdy"
                        :options="{
                          chart: { type: 'bar', height: 350 },
                          plotOptions: { bar: { horizontal: true } },
                          dataLabels: { enabled: false },
                          xaxis: {
                            categories:
                              chart1Obj.flat.requestByLocation.list.map((x) => {
                                return x.type;
                              }),
                          },
                        }"
                        :series="[
                          {
                            data: chart1Obj.flat.requestByLocation.list.map(
                              (x) => {
                                return x.count;
                              }
                            ),
                          },
                        ]"
                      ></apexcharts>
                    </div>
                  </div>
                </div>
              </div> -->

              <div class="col-md-12 mg-t-0 pd-t-0">
                <div class="card">
                  <div class="card-header pd-b-0 pd-x-20 bd-b-0">
                    <div
                      class="
                        d-sm-flex
                        align-items-center
                        justify-content-between
                      "
                    >
                      <h6 class="mg-b-0">Саатсан шалтгааны дуудлага</h6>
                    </div>
                  </div>
                  <div class="card-body pd-20">
                    <table class="table table-bordered" v-if="chart1Obj.rdy">
                      <thead>
                        <th>Саатсан шалтгааны дуудлага</th>

                        <th
                          v-for="(callReason, ocri) in chart1Obj.flat.callData
                            .openCallReasons"
                          :key="`ocri1_${ocri}`"
                        >
                          {{ callReason }}
                        </th>
                        <th><b>Нийт</b></th>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(deviceCode, dki) in chart1Obj.flat.callData
                            .openCallDeviceCodes"
                          :key="`dki_${dki}`"
                        >
                          <td>{{ deviceCode }}</td>
                          <td
                            v-for="(callReason, ocri) in chart1Obj.flat.callData
                              .openCallReasons"
                            :key="`ocri2_${ocri}`"
                          >
                            {{
                              chart1Obj.flat.callData.openCalls.filter(
                                (x) =>
                                  x.parentDevice.type.code == deviceCode &&
                                  x.reason.name == callReason
                              ).length
                            }}
                          </td>
                          <td>
                            <b>
                            {{
                              chart1Obj.flat.callData.openCalls.filter(
                                (x) =>
                                  x.parentDevice.type.code == deviceCode
                              ).length
                            }}</b>
                          </td>
                        </tr>
                        <tr>
                          <td><b>Нийт</b>
                          </td>
                          <td v-for="(callReason, ocri) in chart1Obj.flat.callData.openCallReasons"
                            :key="`ocri3_${ocri}`">
                            <b>
                              {{
                              chart1Obj.flat.callData.openCalls.filter(
                                (x) =>                                  
                                  x.reason.name == callReason
                              ).length
                            }}
                            </b>
                          </td>
                          <td>
                            <b>
                              {{
                              chart1Obj.flat.callData.openCalls.length
                            }}
                            </b>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="col-md-6 mg-t-0 pd-t-0">
                <div class="card">
                  <div class="card-header pd-b-0 pd-x-20 bd-b-0">
                    <div
                      class="
                        d-sm-flex
                        align-items-center
                        justify-content-between
                      "
                    >
                      <h6 class="mg-b-0">Сүүлд хийгдсэн үйлдлүүд</h6>
                    </div>
                  </div>
                  <div class="card-body pd-20">
                    <ul class="activity tx-13">
                      <li
                        v-for="(n, i) in notifications"
                        :key="i"
                        class="activity-item"
                      >
                        <div class="activity-icon bg-primary-light tx-primary">
                          <feather
                            type="clock"
                            :title="n.date | moment('yyyy-MM-DD HH:mm:ss')"
                          ></feather>
                        </div>
                        <div class="activity-body">
                          <p class="mg-b-2">
                            <strong>{{ n.user.fullName }}</strong>
                            {{ n.projectOtName }}
                            <span
                              @click="showDetail({ id: n.task.id })"
                              role="button"
                              class="link-02"
                            >
                              <strong>
                                <template v-if="n.mainType == 1"
                                  >{{ n.project.nm }}&nbsp;</template
                                >
                                <template v-else-if="n.mainType == 2"
                                  >{{ n.task.task }}&nbsp;</template
                                >
                                <template v-else-if="n.mainType == 6"
                                  >{{ n.attachment.n }}&nbsp;</template
                                >
                                <template v-else-if="n.mainType == 364"
                                  >{{ n.column.col }}&nbsp;</template
                                >
                              </strong>
                            </span>
                            <u style="font-style: italic">{{ n.otName }}</u>
                            {{ n.actionWord }}
                          </p>
                          <small class="tx-color-03">{{
                            n.date | moment("from")
                          }}</small>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="col-md-6 mg-t-0 pd-t-0">
                <div class="card">
                  <div class="card-header pd-b-0 pd-x-20 bd-b-0">
                    <h6 class="mg-b-0">Засвар арчлалт ангилалаар</h6>
                  </div>
                  <div class="card-body pd-t-25">
                    <!-- {{ chart1Obj.flat.workOrderData.workOrdersByType }} -->
                    <table class="table tabl-bordered table-striped mg-b-0-f">
                      <thead>
                        <th>Ангилал</th>
                        <th>Тоо</th>
                      </thead>
                      <tbody v-if="chart1Obj.rdy">
                        <tr
                          v-for="(workOrder, i) in chart1Obj.flat.workOrderData
                            .workOrdersByType"
                          :key="i"
                          role="button"
                          @click="
                            $router.push({
                              name: 'cmmsWorkOrders',
                              params: {
                                ot: 508,
                                edit: 0,
                                detail: 0,
                                currentColumnId: 0,
                                locTypeId: workOrder.id,
                                locTypeId1: 0,
                                isCompleted: false,
                                task1_ltId3: 0,
                                task2_ltId: 0,
                              },
                            })
                          "
                        >
                          <td>
                            <a href="javascript:void(0)">{{
                              workOrder.name
                            }}</a>
                          </td>
                          <td>{{ workOrder.count }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <!-- <div
                      @click="showTicketsByUser(p.user)"
                      v-for="(p, i) in pinnedList"
                      :key="i"
                      class="media mg-b-10"
                      role="button"
                    >
                      <div class="avatar">
                        <img
                          :src="`${p.user.avator}`"
                          class="rounded-circle"
                          alt
                        />
                      </div>
                      <div class="media-body mg-l-15">
                        <h6 class="tx-13 mg-b-2">{{ p.user.fullName }}</h6>
                        <p class="tx-color-03 tx-12 mg-b-10">
                          {{ p.user.position }}
                        </p>
                        <div class="progress ht-4 op-7 mg-b-5">
                          <div
                            class="progress-bar wd-85p"
                            role="progressbar"
                            aria-valuenow="85"
                            aria-valuemin="0"
                            aria-valuemax="100"
                          ></div>
                        </div>
                        <div class="d-flex justify-content-between tx-12">
                          <span class="tx-color-03">{{ p.user.mobile }}</span>
                          <strong class="tx-medium">{{ p.pinnedCount }}</strong>
                        </div>
                      </div>
                    </div> -->
                  </div>
                </div>
                <div class="card mg-t-10">
                  <div class="card-header pd-b-0 pd-x-20 bd-b-0">
                    <h6 class="mg-b-0">Засвар арчлалт эх үүсвэрээр</h6>
                  </div>
                  <div class="card-body pd-t-25">
                    <!-- {{ chart1Obj.flat.workOrderData.workOrdersByType }} -->
                    <table class="table tabl-bordered table-striped mg-b-0-f">
                      <thead>
                        <th>Эх үүсвэр</th>
                        <th>Тоо</th>
                      </thead>
                      <tbody v-if="chart1Obj.rdy">
                        <tr
                          role="button"
                          v-for="(workOrder, i) in chart1Obj.flat.workOrderData
                            .workOrdersBySource"
                          :key="i"
                          @click="
                            $router.push({
                              name: 'cmmsWorkOrders',
                              params: {
                                ot: 508,
                                edit: 0,
                                detail: 0,
                                currentColumnId: 0,
                                locTypeId: 0,
                                locTypeId1: workOrder.id,
                                isCompleted: false,
                                task1_ltId3: 0,
                                task2_ltId: 0,
                              },
                            })
                          "
                        >
                          <td>
                            <a href="javascript:void(0)">{{
                              workOrder.name
                            }}</a>
                          </td>
                          <td>{{ workOrder.count }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="card mg-t-10">
                  <div class="card-body">
                    <h6 class="">
                      <u>Засварийн ажлын гүйцэтгэл</u>
                    </h6>
                    <!-- {{chart1Obj.flat.guitsetgel}} {{chart1Obj.flat.allSum}} -->
                    <ul
                      class="
                        list-inline
                        tx-uppercase tx-10 tx-medium tx-spacing-1
                        mg-b-0
                      "
                    >
                      <li v-for="(c, i) in chart1Obj.flat.columns" :key="i">
                        <div class="d-flex justify-content-between">
                          <div>
                            <span
                              class="
                                d-inline-block
                                wd-7
                                ht-7
                                rounded-circle
                                mg-r-5
                              "
                              :style="{ 'background-color': c.column.color }"
                            ></span>
                            {{ c.column.name }}
                          </div>
                          <div>{{ c.column.shortName }}</div>
                        </div>
                      </li>
                    </ul>

                    <div class="mg-t-20">
                      <div
                        @click="showTicketsByUser(g.user)"
                        class="media"
                        v-for="(g, i) in chart1Obj.flat.guitsetgel"
                        :key="i"
                        :class="{ 'mg-t-10': i > 0 }"
                        role="button"
                      >
                        <div class="avatar">
                          <img
                            :src="g.user.avator"
                            class="rounded-circle"
                            alt
                          />
                        </div>
                        <div class="media-body mg-l-15">
                          <div class="d-flex justify-content-between">
                            <h6 class="tx-13 mg-b-2">
                              {{ g.user.fullName }}
                            </h6>
                            <span class="tx-12"
                              >{{ g.sum }} 
                              <!-- /{{ g.percByAll }}%/ -->
                              </span
                            >
                          </div>

                          <div class="progress ht-20 op-7 mg-b-5">
                            <div
                              v-for="(p, i) in g.stat"
                              :key="i"
                              class="progress-bar font-weight-bold"
                              :style="{
                                width: p.perc + '%',
                                'background-color': p.color,
                              }"
                            >
                              {{ p.count }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="col-md-12 mg-t-0 pd-t-0">
              <div class="card">
                <div
                  class="
                    card-header
                    d-flex
                    align-items-center
                    justify-content-between
                  "
                >
                  <h6 class="mg-b-0">Хаагдаагүй дуудлагууд</h6>
                  <div class="d-flex tx-18">
                    <!-- <a href class="link-03 lh-0">
                      <i class="icon ion-md-refresh"></i>
                    </a>
                    <a href class="link-03 lh-0 mg-l-10">
                      <i class="icon ion-md-more"></i>
                    </a> -->
                  </div>
                </div>
                <ul class="list-group list-group-flush tx-13">
                  <li
                    @click="
                      taskDialogSide.id = 0;
                      showDetail(r);
                    "
                    class="list-group-item d-flex pd-sm-x-20"
                    v-for="(r, i) in recentList"
                    :key="i"
                    role="button"
                  >
                    <div class="avatar d-none d-sm-block">
                      <span class="avatar-initial rounded-circle bg-indigo">
                        <!-- TCS10 -->
                        <img
                          :src="`${myResBaseUrl}apps/asset/${r.parentDevice.type.code}.png?w=24`"
                        />
                        <!-- <feather :type="r.parentDevice.type.name"></feather> -->
                      </span>
                    </div>
                    <div class="pd-sm-l-10">
                      <p class="tx-medium mg-b-2">
                        {{ r.site.prefix.replace("Loc-", "") }} -
                        {{ r.reason.name }} ({{ r.shortInfo.name }})
                      </p>
                      <div>
                        {{ r.site.name }} - {{ r.parentDevice.deviceName }}
                      </div>
                    </div>
                    <div class="mg-l-auto text-right">
                      <div class="tx-12 tx-color-03 mg-b-0">
                        {{ r.createdDate | moment("YYYY-MM-DD") }}<br />
                        <span>
                          {{ r.createdDate | moment("HH:mm:SS") }}
                        </span>
                      </div>
                      <small class="tx-12 tx-success mg-b-0">{{
                        r.isCompleted ? "дууссан" : ""
                      }}</small>
                    </div>
                  </li>
                </ul>
                <div class="card-footer text-center tx-13">
                  <router-link to="/cmms/calls/507/0/0/0" class="link-03">
                    Бүх дуудлагыг харах
                    <i class="icon ion-md-arrow-down mg-l-5"></i>
                  </router-link>
                </div>
                <!-- card-footer -->
              </div>
            </div>

            <div class="col-md-12 mg-t-0 pd-t-0">
              <div class="card">
                <div
                  class="
                    card-header
                    d-flex
                    align-items-center
                    justify-content-between
                  "
                >
                  <h6 class="mg-b-0">Ажлын бус цаг</h6>
                  <div class="d-flex tx-18">
                  </div>
                </div>
                <ul class="list-group list-group-flush tx-13">
                  <li
                    @click="
                      taskDialogSide.id = 0;
                      showDetail(r);
                    "
                    class="list-group-item d-flex pd-sm-x-20"
                    v-for="(r, i) in iluuTsagList"
                    :key="i"
                    role="button"
                  >
                    <div class="avatar d-none d-sm-block">
                      <span class="avatar-initial rounded-circle bg-indigo">
                        <!-- TCS10 -->
                        <img
                          :src="`${myResBaseUrl}apps/asset/${r.parentDevice.type.code}.png?w=24`"
                        />
                      </span>
                    </div>
                    <div class="pd-sm-l-10">
                      <p class="tx-medium mg-b-2">
                        {{ r.site.prefix.replace("Loc-", "") }} -
                        <!-- {{ r.reason.name }} ({{ r.shortInfo.name }}) -->
                      </p>
                      <div>
                        {{ r.site.name }} - {{ r.parentDevice.deviceName }}
                      </div>
                    </div>
                    <div class="mg-l-auto text-right">
                      <div class="tx-12 tx-color-03 mg-b-0">
                        {{ r.createdDate | moment("YYYY-MM-DD") }}<br />
                        <span>
                          {{ r.createdDate | moment("HH:mm:SS") }}
                        </span>
                      </div>
                      <small class="tx-12 tx-success mg-b-0">{{
                        r.isCompleted ? "дууссан" : ""
                      }}</small>
                    </div>
                  </li>
                </ul>
                <div class="card-footer text-center tx-13">
                  <router-link to="/cmms/iluutsag/535/0/0/0" class="link-03">
                    Бүх ажлын бус цагийг харах
                    <i class="icon ion-md-arrow-down mg-l-5"></i>
                  </router-link>
                </div>
                <!-- card-footer -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <task-edit
        :prms.sync="taskEdit"
        :show.sync="taskEdit.show"
        @on-task-posted="
          posted($event);
          filterReset();
        "
        @on-edit-close="editClosed"
      ></task-edit>

      <task-detail-side
        v-if="taskDialogSide.id > 0"
        :id.sync="taskDialogSide.id"
        @on-task-close="
          taskDialogSide.id = 0;
          filterReset();
        "
      ></task-detail-side>

      <b-modal
        id="modal-usersTicket"
        v-model="selectedUserTickets.modal"
        :title="modalTitle"
        hide-footer
        no-fade
        centered
      >
        <ul
          class="list-unstyled media-list mg-b-15"
          v-if="selectedUserTickets.info != null"
        >
          <li class="media align-items-center">
            <a>
              <div class="avatar">
                <img
                  :src="selectedUserTickets.info.avator"
                  class="rounded-circle"
                  alt
                />
              </div>
            </a>
            <div class="media-body pd-l-15">
              <p class="tx-medium mg-b-2">
                <a class="link-01">{{ selectedUserTickets.info.fullName }}</a>
              </p>
              <span class="tx-12 tx-color-03">{{
                selectedUserTickets.info.position
              }}</span>
            </div>
          </li>
        </ul>

        <ul
          class="list-group list-group-flush tx-13"
          v-if="selectedUserTickets.rdy"
        >
          <li
            @click="
              selectedUserTickets.modal = false;
              showDetail(r.ticket);
            "
            class="list-group-item d-flex pd-sm-x-20"
            v-for="(r, i) in selectedUserTickets.list"
            :key="i"
            role="button"
          >
            <div class="avatar d-none d-sm-block">
              <span class="avatar-initial rounded-circle bg-indigo op-5">
                <feather
                  v-if="
                    r.device.type.value != null && r.device.type.value != ''
                  "
                  :type="r.device.type.value"
                ></feather>
              </span>
            </div>
            <div class="pd-sm-l-10">
              <p class="tx-medium mg-b-2">{{ r.ticket.task }}</p>
              <div>Тоног төхөөрөмж: {{ r.device.deviceName }}</div>
              <div>Цэг уулзвар: {{ r.device.location.parentName }}</div>
            </div>
            <div class="mg-l-auto text-right">
              <small class="tx-12 tx-color-03 mg-b-0">{{
                r.ticket.createdDate | moment("yyyy-MM-DD HH:mm:ss")
              }}</small
              ><br />
              <small class="tx-12 tx-color-03 mg-b-0">{{
                r.ticket.dueDate | moment("yyyy-MM-DD HH:mm:ss")
              }}</small>
              <!-- {{r.perc}} -->
              <small class="tx-12 tx-success mg-b-0">{{
                r.ticket.isCompleted ? "Completed" : ""
              }}</small>
            </div>
          </li>
        </ul>
      </b-modal>

      <b-modal
        id="assetHomeModal"
        v-model="deviceModal.show"
        :title="deviceModal.obj.title"
        no-fade
        centered
        size="xl"
        class="assetHomeModal"
        style="z-index: 1034 !important"
      >
        <div style="max-height: 60vh; overflow-y: auto">
          <div v-html="deviceModal.obj.info"></div>
          <div v-if="deviceModal.siteInfo != null">
            <div class="card ht-lg-100p">
              <div
                class="
                  card-header
                  d-flex
                  align-items-center
                  justify-content-between
                "
              >
                <h6 class="mg-b-0">Идэвхтэй дуудлагууд</h6>
              </div>
              <div class="card-body pd-0">
                <div v-if="deviceModal.siteInfo.cmmsCalls.length > 0">
                  <div class="table-responsive">
                    <table class="table table-dashboard mg-b-0 bd-t-0 tx-13">
                      <thead>
                        <tr>
                          <th>Код</th>
                          <th>Шалтгаан</th>
                          <th>Товч тайлбар</th>
                          <th>Үүсгэсэн</th>
                          <th>Үйлдэл</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(call, ci) in deviceModal.siteInfo.cmmsCalls"
                          :key="`cll` + ci"
                        >
                          <td style="width: 180px">{{ call.code }}</td>
                          <td style="width: 240px">
                            {{ call.reason.name }}
                          </td>
                          <td style="width: 240px">
                            {{ call.shortInfo.name }}
                          </td>
                          <td>
                            {{ call.createdDate | moment("YYYY-MM-DD HH:mm") }}
                          </td>
                          <td>
                            <button
                              @click="showDetail({ id: call.id })"
                              class="
                                btn btn-xs btn-primary
                                text-white
                                pd-y-2 pd-x-5
                                btn-uppercase
                                mg-l-auto
                              "
                            >
                              дэлгэрэнгүй
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div v-else class="pd-10 text-center">
                  Идэвхтэй дуудлага бүртгэгдээгүй байна.
                </div>
              </div>
            </div>

            <div class="card ht-lg-100p mg-t-20">
              <div
                class="
                  card-header
                  d-flex
                  align-items-center
                  justify-content-between
                "
              >
                <h6 class="mg-b-0">Идэвхтэй засвар үйлчилгээнүүд</h6>
              </div>
              <div class="card-body pd-0">
                <div v-if="deviceModal.siteInfo.workOrders.length > 0">
                  <div class="table-responsive">
                    <table class="table mg-b-0 bd-t-0 table-dashboard tx-13">
                      <thead>
                        <tr>
                          <th>Код</th>
                          <th>Ангилал</th>
                          <th>Төлөв</th>
                          <th>Үүсгэсэн</th>
                          <th>Үйлдэл</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(work, wi) in deviceModal.siteInfo.workOrders"
                          :key="`wrk` + wi"
                        >
                          <td style="width: 180px">{{ work.code }}</td>
                          <td style="width: 240px">
                            {{ work.type.name }}
                          </td>
                          <td style="width: 240px">
                            {{ work.source.name }}
                          </td>
                          <td>
                            {{ work.createdDate | moment("YYYY-MM-DD HH:mm") }}
                          </td>
                          <td>
                            <button
                              @click="showDetail({ id: work.id })"
                              class="
                                btn btn-xs btn-primary
                                text-white
                                pd-y-2 pd-x-5
                                btn-uppercase
                                mg-l-auto
                              "
                            >
                              дэлгэрэнгүй
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div v-else class="pd-10 text-center">
                  Идэвхтэй засвар үйлчилгээ бүртгэгдээгүй байна.
                </div>
              </div>
            </div>

            <!-- {{ deviceModal.siteInfo }} -->
          </div>
        </div>
        <template #modal-footer>
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <b-button
            size="sm"
            variant="success"
            @click="
              deviceModal.show = false;
              editShow(
                0,
                deviceModal.obj.title,
                deviceModal.obj.deviceId,
                deviceModal.obj.firstDeviceId, 507
              );
            "
            >Дуудлага бүртгэх</b-button
          >

          <b-button
            size="sm"
            variant="warning"
            @click="
              deviceModal.show = false;
              editShow(
                0,
                deviceModal.obj.title,
                deviceModal.obj.deviceId,
                deviceModal.obj.firstDeviceId, 508
              );
            "
            >Засвар арчлалт бүртгэх</b-button
          >

          <!-- <b-button
            v-if="deviceModal.obj.color != 'green'"
            size="sm"
            variant="danger"
            @click="
              deviceModal.show = false;
              showDetail({ id: deviceModal.obj.ticketId });
            "
            >Дуудлагын дэлгэрэнгүй</b-button
          > -->
          <!-- Button with custom close trigger value -->
          <b-button
            size="sm"
            variant="outline-secondary"
            @click="
              deviceModal.show = false;
              showDetail({ id: deviceModal.obj.deviceId });
            "
            >Уулзвар цэгийн дэлгэрэнгүй</b-button
          >
        </template>
      </b-modal>

      <b-modal
        id="eeljChooserModal"
        v-model="eeljChooserModal.show"
        title="Ээлж сонгох"
        no-fade
        centered
        size="sm"
        class="eeljChooserModal"
        style="z-index: 1034 !important"
      >
        <div style="max-height: 60vh; overflow-y: auto">
          <div>
            <RadioGroup v-model="eeljChooserModal.data.typeId">
              <Radio
                :label="type.id"
                v-for="(type, i) in eeljChooserModal.data.types"
                :key="`tt${i}`"
              >
                <span>{{ type.title }}</span>
              </Radio>
            </RadioGroup>
          </div>
        </div>
        <template #modal-footer>
          <b-button size="sm" variant="outline-secondary" @click="saveEelj()"
            >Хадгалах</b-button
          >
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { request } from "@/api/all";
const moment = require("moment");

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { mapActions } from "vuex";

import { DatePicker, RadioGroup, Radio } from "element-ui";
import Buttons from "../../../../components/task/components/transfers/buttons.vue";
import { hasOneOf } from "@/libs/tools";

export default {
  components: {
    DatePicker,
    RadioGroup,
    Radio,
    apexcharts: VueApexCharts,
    taskEdit: () => ({
      component: import("@/components/task/edit/base"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskDetailSide: () => ({
      component: import("@/components/task/detail/dialog.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    locTypeCascader: () => ({
      component: import("@/components/task/edit/components/locTypeCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    hrmSelect: () => ({
      component: import(
        "@/components/task/edit/components/hrmSelect/hrmSelect.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    Buttons,
  },
  data: function () {
    return {
      modalTitle: "Хэрэглэгчид хуваарилагдсан дуудлагууд",
      myResBaseUrl: "https://res.gosmart.mn/",
      filter: {
        types: [
          { id: null, title: "Бүгд", icon: "video" },
          { id: 46703, title: "Гадна тоног төхөөрөмж", icon: "video" },
          {
            id: 46704,
            title: "Мэдээлэл технологийн тоног төхөөрөмж",
            icon: "video",
          },
        ],
        typeCur: null,
        categories: [],
        categoryCur: null,
        locations: [],
        locationCur: null,
        hrmCreated: null,
        hrmPinned: null,
        date: [],
        onlineStatusId: null,
        sitePrefix: null,
        sitePrefixContain: true,
      },
      project: {
        id: null,
      },
      taskEdit: {
        id: 0,
        show: false,
        render: false,
        objectTypeId: 0,
        projectId: 0,
      },

      chart1Obj: {
        rdy: false,
        series: [],
        flat: {},
        option: {
          chart: {
            height: 350,
            type: "line",
            stacked: false,
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            width: [1, 1, 4],
          },
          title: {
            text: "Хөдөлгөөн зохицуулалт графикаар",
            align: "left",
            offsetX: 110,
          },
          xaxis: {
            categories: [],
          },
          yaxis: [
            {
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: "#008FFB",
              },
              labels: {
                style: {
                  colors: "#008FFB",
                },
              },
              title: {
                text: "Ирсэн",
                style: {
                  color: "#008FFB",
                },
              },
              tooltip: {
                enabled: true,
              },
            },
            {
              seriesName: "Income",
              opposite: true,
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: "#00E396",
              },
              labels: {
                style: {
                  colors: "#00E396",
                },
              },
              title: {
                text: "Шийдвэрлэсэн",
                style: {
                  color: "#00E396",
                },
              },
            },
            {
              seriesName: "Revenue",
              opposite: true,
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: "#FEB019",
              },
              labels: {
                style: {
                  colors: "#FEB019",
                },
              },
              title: {
                text: "Нээлттэй",
                style: {
                  color: "#FEB019",
                },
              },
            },
          ],
          tooltip: {
            fixed: {
              enabled: true,
              position: "topLeft", // topRight, topLeft, bottomRight, bottomLeft
              offsetY: 30,
              offsetX: 60,
            },
          },
          legend: {
            horizontalAlign: "left",
            offsetX: 40,
          },
        },
      },

      googleMapMaker: [],

      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,

      infoOptions: {
        content: "",
        //optional: offset infowindow so it visually sits nicely on top of our marker
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },

      recentList: [],
      iluuTsagList:[],
      asset: {
        recentList: [],
      },
      notifications: [],
      taskDialogSide: {
        show: false,
        id: 0,
        key: 0,
      },
      pinnedList: [],
      selectedUserTickets: {
        info: {},
        list: [],
        rdy: false,
        modal: false,
      },

      deviceModal: {
        show: false,
        obj: {},
        siteInfo: null,
      },
      serverTemp: {
        ip: "",
        name: "",
        macaddr: "",
        sensor: [],
      },
      serverTempLastUpdated: "",
      timer: "",
      eeljChooserModal: {
        show: false,
        data: {
          types: [],
          typeId: null,
        },
      },
      specialCallDataRdy: false,
      specialCallData: [],
    };
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  created() {
    if (
      this.$store.state.app.activeGroup.resBaseUrl != undefined &&
      this.$store.state.app.activeGroup.resBaseUrl != ""
    ) {
      this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
    }
  },
  mounted() {
    this.filter.date.push(
      moment().clone().startOf("year").format("YYYY-MM-DD hh:mm")
    );
    this.filter.date.push(
      moment().clone().endOf("month").format("YYYY-MM-DD hh:mm")
    );
    this.getServerTemperature();
    this.eeljChooserModal.data.typeId =
      this.$store.state.user.userInfo.locTypeId15;
    this.init();

    this.$refs.map.$mapPromise.then((map) => {
      map.setOptions({
        styles: [
          {
            featureType: "poi",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "transit",
            elementType: "labels.icon",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "administrative.neighborhood",
            elementType: "labels",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          // {
          //   featureType: "administrative.land_parcel",
          //   elementType: "labels",
          //   stylers: [
          //     {
          //       visibility: "off",
          //     },
          //   ],
          // },
          {
            featureType: "administrative.locality",
            elementType: "labels",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          // {
          //   featureType: 'road',
          //   elementType: 'labels',
          //   stylers: [{ visibility: 'off' }],
          // },
        ],
      });
    });
  },
  updated() {
    //this.featherReplace();
  },
  methods: {
    ...mapActions(["handleLoading", "handleUserInfo"]),
    hasPermission(arr) {
      if (this.$store.state.user.userId == "") return false;
      return hasOneOf(this.$store.state.user.userInfo.access, arr);
    },
    checkEnter(e) {
      if (e.keyCode === 13) {
        this.filter.sitePrefixContain = false;
        this.chart1();
      }
    },
    saveEelj() {
      // alert(this.eeljChooserModal.data.typeId);
      request({
        api: { method: "POST", url: "hr/saveLocTypeId15" },
        data: { id: this.eeljChooserModal.data.typeId },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.eeljChooserModal.show = false;
          this.handleUserInfo({ store: this.$store });
          this.$bvToast.toast(`Амжилттай хадгаллаа.`, {
            title: "Мэдэгдэл",
            autoHideDelay: 3000,
            appendToast: true,
            variant: "success",
            toaster: "b-toaster-bottom-left",
          });
        }
      });

      //userStore shinechleh
    },
    searchBySitePrefix(prefix, sitePrefixContain) {
      this.filter.sitePrefixContain = sitePrefixContain;

      this.filter.sitePrefix = prefix;
      this.chart1();
    },
    init() {
      this.timer = setInterval(() => {
        this.getServerTemperature();
      }, 30000);

      let prjs = this.$store.state.app.groupDefaultProjects.filter(
        (x) => x.objectTypeId == 498
      );
      if (prjs != undefined && prjs.length) {
        this.project = prjs[0];
        this.chart1();
      }

      request({
        api: { method: "GET", url: "type/getTreeData" },
        params: { key: "delayType" },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.filter.categories = res.data.types;
        }
      });
      request({
        api: { method: "GET", url: "type/getTreeData" },
        params: { key: "assetLocation" },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.filter.locations = res.data.types.filter((x) => x.parentId == 0);
        }
      });

      request({
        api: { method: "GET", url: "type/getTreeData" },
        params: { key: "assetEeljType" },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.eeljChooserModal.data.types = res.data.types.filter(
            (x) => x.parentId == 0
          );
        }
      });

      request({
        api: { method: "GET", url: "Notification/GetNotification" },
        params: { page: "0", size: 10 },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.notifications = res.data.notifications;
        }
      });
      if (
        this.hasPermission(["asseteeljchooser"]) &&
        this.eeljChooserModal.data.typeId == null
      ) {
        this.eeljChooserModal.show = true;
      }
    },
    posted(e) {
      //console.log('posted', e);
      if (e.afterMode == 101) {
        //this.showDetail(e.obj);
      } else if (e.afterMode == -99) {
        this.showDetail(e.obj);
      } else if (e.afterMode == 102)
        this.editShow(0, "", e.obj.organizationTaskId, e.obj.secondOrganizationTaskId,e.obj.objectTypeId);
    },
    getServerTemperature() {
      request({
        api: { method: "GET", url: "asset/GetServerRoomTemperature" },
        params: {},
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.serverTemp = res.data.temperature;
          this.serverTempLastUpdated = moment().format("YYYY-MM-DD HH:mm:ss");
          //console.log("GetServerRoomTemperature=> ", res);
        }
      });
    },
    toggleInfoWindow(marker, idx) {
      //console.log(marker, idx);
      // this.showDetail(marker);
      // this.infoWindowPos = marker.position;
      // this.infoOptions.content = marker.info;

      // //check if its the same marker that was selected if yes toggle
      // if (this.currentMidx == idx) {
      //   this.infoWinOpen = !this.infoWinOpen;
      // }

      // //if different marker set infowindow to open and reset current marker index
      // else {
      //   this.infoWinOpen = true;
      //   this.currentMidx = idx;
      // }

      //# modal neev

      //marker.deviceId

      this.handleLoading({ isLoading: true });
      request({
        api: { method: "get", url: "Asset/SiteInfo" },
        params: {
          siteId: marker.deviceId,
        },
        store: this.$store,
      }).then((res) => {
        this.handleLoading({ isLoading: false });
        this.deviceModal.siteInfo = res.data;
        //.cmmsCalls
      });
      this.deviceModal.show = true;
      this.deviceModal.obj = marker;
    },
    filterReset() {
      this.filter.typeCur = null;
      this.filter.locationCur = null;
      this.filter.categoryCur = null;
      this.filter.sitePrefix = null;
      this.filter.date = [];
      this.filter.date.push(
        moment().clone().startOf("year").format("YYYY-MM-DD hh:mm")
      );
      this.filter.date.push(
        moment().clone().endOf("month").format("YYYY-MM-DD hh:mm")
      );

      this.filter.hrmCreated = null;
      this.filter.hrmPinned = null;
      this.filter.onlineStatusId = null;
      this.filter.sitePrefixContain = true;
      this.chart1();
    },
    searchByWorkAndCall(type){
//this.chart1Obj.flat
if(type=='work')
{
this.googleMapMaker = this.chart1Obj.flat.mapData.sites
            .filter(
              (t) =>
                t.device.location.lat != null && t.device.location.lng != null
                && t.hasWork==true
            )
            .map((x) => {
              //console.log(`${x.device.type.code}-${x.mapFlag.color}`);
              return {
                id:
                  x.ticket != undefined && x.ticket != null
                    ? x.ticket.id
                    : null,
                title: x.device.deviceName,
                info:
                  x.ticket != undefined && x.ticket != null
                    ? `
                <h4>${moment(x.ticket.createdDate).format(
                  "YYоны MM-р сар DD. HHц:mmм"
                )}</h4>
                <ul class="list-group wd-500">
                  <li class="list-group-item d-flex align-items-center">
                    <div>
                      <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">${
                        x.ticket.task
                      }</h6>
                      <span class="d-block tx-11 text-muted">товч утга</span>
                    </div>
                  </li>
                  <li class="list-group-item active d-flex align-items-center">
                    <div>
                      <h6 class="tx-13 tx-white tx-semibold mg-b-0">${
                        x.device.deviceName
                      }</h6>
                      <span class="d-block tx-11 text-white">төхөөрөмж</span>
                    </div>
                  </li>
                  <li class="list-group-item d-flex align-items-center">
                    <div>
                      <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">${
                        x.ticket.type.name
                      }</h6>
                      <span class="d-block tx-11 text-muted">ангилал</span>
                    </div>
                  </li>
                  
                </ul>
          `
                    : "",
                // <li class="list-group-item d-flex align-items-center">
                //           <a @click="${this.showDetail(x)}">Дэлгэрэнгүй</a>
                //         </li>
                position: {
                  lat: parseFloat(x.device.location.lat),
                  lng: parseFloat(x.device.location.lng),
                },
                icon: `${x.device.deviceType.code}-${x.mapFlag.color}`,
                color: x.mapFlag.color,
                deviceId: x.device.id,
                firstDeviceId: x.firstDeviceId,
                ticketId:
                  x.ticket != undefined && x.ticket != null
                    ? x.ticket.id
                    : null,
              };
            });
}else if(type=='call')
{
this.googleMapMaker = this.chart1Obj.flat.mapData.sites
            .filter(
              (t) =>
                t.device.location.lat != null && t.device.location.lng != null
                && t.hasCall==true
            )
            .map((x) => {
              //console.log(`${x.device.type.code}-${x.mapFlag.color}`);
              return {
                id:
                  x.ticket != undefined && x.ticket != null
                    ? x.ticket.id
                    : null,
                title: x.device.deviceName,
                info:
                  x.ticket != undefined && x.ticket != null
                    ? `
                <h4>${moment(x.ticket.createdDate).format(
                  "YYоны MM-р сар DD. HHц:mmм"
                )}</h4>
                <ul class="list-group wd-500">
                  <li class="list-group-item d-flex align-items-center">
                    <div>
                      <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">${
                        x.ticket.task
                      }</h6>
                      <span class="d-block tx-11 text-muted">товч утга</span>
                    </div>
                  </li>
                  <li class="list-group-item active d-flex align-items-center">
                    <div>
                      <h6 class="tx-13 tx-white tx-semibold mg-b-0">${
                        x.device.deviceName
                      }</h6>
                      <span class="d-block tx-11 text-white">төхөөрөмж</span>
                    </div>
                  </li>
                  <li class="list-group-item d-flex align-items-center">
                    <div>
                      <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">${
                        x.ticket.type.name
                      }</h6>
                      <span class="d-block tx-11 text-muted">ангилал</span>
                    </div>
                  </li>
                  
                </ul>
          `
                    : "",
                // <li class="list-group-item d-flex align-items-center">
                //           <a @click="${this.showDetail(x)}">Дэлгэрэнгүй</a>
                //         </li>
                position: {
                  lat: parseFloat(x.device.location.lat),
                  lng: parseFloat(x.device.location.lng),
                },
                icon: `${x.device.deviceType.code}-${x.mapFlag.color}`,
                color: x.mapFlag.color,
                deviceId: x.device.id,
                firstDeviceId: x.firstDeviceId,
                ticketId:
                  x.ticket != undefined && x.ticket != null
                    ? x.ticket.id
                    : null,
              };
            });
}

    },
    chart1() {
      this.handleLoading({ isLoading: true });

      request({
        api: { method: "get", url: "Asset/GetSpecialCallData" },
        params: {
          //startDate: this.filter.date[0],
          //endDate: this.filter.date[1],
        },
        store: this.$store,
      }).then((res) => {
        this.specialCallData = res.data.list;
        this.specialCallDataRdy = true;
      });
      request({
        api: { method: "POST", url: "asset/currentTicketStatus" },
        data: {
          startDate: this.filter.date[0],
          endDate: this.filter.date[1],
          groupMode: 1, //# 1udruud, 2saraar, 3ulirlaar,
          assetTypeId: this.filter.typeCur,
          breakDownDelayTypeId: this.filter.categoryCur,
          assetLocationId: this.filter.locationCur,
          page: 0,
          size: 10,
          userCreatedId: this.filter.hrmCreated,
          userPinnedId: this.filter.hrmPinned,
          onlineStatusId: this.filter.onlineStatusId,
          sitePrefix: this.filter.sitePrefix,
          sitePrefixContain: this.filter.sitePrefixContain,
        },
        store: this.$store,
      }).then((res) => {
        this.handleLoading({ isLoading: false });
        if (res != false) {
          //console.log('currentTicketStatus=> ', res.data);
          this.chart1Obj.flat = res.data;
          // this.chart1Obj.option.xaxis.categories= res.data.newTicket.list.map((x)=>{ return moment(x.key).format("MM.DD") });

          this.chart1Obj.series = [
            {
              name: "Ирсэн",
              type: "column",
              data: res.data.newTicket.list.map((x) => {
                return x.count;
              }),
            },
            {
              name: "Шийдвэрлэсэн",
              type: "column",
              data: res.data.solved.list.map((x) => {
                return x.count;
              }),
            },
            {
              name: "Нээлттэй",
              type: "line",
              data: res.data.openTicket.list.map((x) => {
                return x.count;
              }),
            },
          ];

          this.pinnedList = res.data.ticketByUser.pinned;
          this.asset = res.data.asset;
          this.recentList = res.data.newTicket.recentList;

          this.iluuTsagList = res.data.iluuTsagData.list;

          //console.log(res.data);
          this.googleMapMaker = res.data.mapData.sites
            .filter(
              (t) =>
                t.device.location.lat != null && t.device.location.lng != null
            )
            .map((x) => {
              //console.log(`${x.device.type.code}-${x.mapFlag.color}`);
              return {
                id:
                  x.ticket != undefined && x.ticket != null
                    ? x.ticket.id
                    : null,
                title: x.device.deviceName,
                info:
                  x.ticket != undefined && x.ticket != null
                    ? `
                <h4>${moment(x.ticket.createdDate).format(
                  "YYоны MM-р сар DD. HHц:mmм"
                )}</h4>
                <ul class="list-group wd-500">
                  <li class="list-group-item d-flex align-items-center">
                    <div>
                      <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">${
                        x.ticket.task
                      }</h6>
                      <span class="d-block tx-11 text-muted">товч утга</span>
                    </div>
                  </li>
                  <li class="list-group-item active d-flex align-items-center">
                    <div>
                      <h6 class="tx-13 tx-white tx-semibold mg-b-0">${
                        x.device.deviceName
                      }</h6>
                      <span class="d-block tx-11 text-white">төхөөрөмж</span>
                    </div>
                  </li>
                  <li class="list-group-item d-flex align-items-center">
                    <div>
                      <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">${
                        x.ticket.type.name
                      }</h6>
                      <span class="d-block tx-11 text-muted">ангилал</span>
                    </div>
                  </li>
                  
                </ul>
          `
                    : "",
                // <li class="list-group-item d-flex align-items-center">
                //           <a @click="${this.showDetail(x)}">Дэлгэрэнгүй</a>
                //         </li>
                position: {
                  lat: parseFloat(x.device.location.lat),
                  lng: parseFloat(x.device.location.lng),
                },
                icon: `${x.device.deviceType.code}-${x.mapFlag.color}`,
                color: x.mapFlag.color,
                deviceId: x.device.id,
                firstDeviceId: x.firstDeviceId,
                ticketId:
                  x.ticket != undefined && x.ticket != null
                    ? x.ticket.id
                    : null,
              };
            });

          //console.log(this.googleMapMaker);

          this.chart1Obj.rdy = true;
        }
      });
    },
    editShow(id, deviceName, deviceId, firstDeviceId, ot) {
      let prjs = this.$store.state.app.groupDefaultProjects.filter(
        (x) => x.objectTypeId == ot
      );

      this.taskEdit.id = id;
      this.taskEdit.objectTypeId = ot;
      this.taskEdit.projectId = prjs[0].id;
      this.taskEdit.render = true;

      if (deviceName != undefined && deviceId != undefined) {
        this.taskEdit.directData = {
          organizationTaskId: deviceId,
          organizationTaskName: deviceName,
          secondOrganizationTaskId: firstDeviceId,
        };
      }
      //console.log(this.taskEdit)
      this.$nextTick(function () {
        this.taskEdit.show = true;
      });
    },
    editClosed(e) {
      //console.log('editClosed=> ', e);
      this.taskEdit.show = false;
      this.taskEdit.id = 0;
    },
    showDetail(e) {
      this.deviceModal.show= false,
      this.taskDialogSide.id = e.id;
    },
    showTicketsByDueDate(flag) {
      this.selectedUserTickets.info = null;

      if (flag == 1) {
        this.modalTitle = "Хугацаа дөхсөн засварын ажлууд";
        this.selectedUserTickets.list =
          this.chart1Obj.flat.workOrderData.notCompletedWorkOrders.filter(
            (x) => x.perc > 70 && x.perc < 100
          );
        //console.log('selectedUserTickets=> ', res.data);
        this.selectedUserTickets.rdy = true;
        this.selectedUserTickets.modal = true;
      } else if (flag == 2) {
        this.modalTitle = "Урт хугацаат засварын ажлууд";
        //this.selectedUserTickets.info = e;
        this.selectedUserTickets.list =
          this.chart1Obj.flat.workOrderData.notCompletedWorkOrders.filter(
            (x) => x.perc >= 100
          );
        //console.log('selectedUserTickets=> ', res.data);
        this.selectedUserTickets.rdy = true;
        this.selectedUserTickets.modal = true;
      }
    },

    showTicketsByUser(e) {
      this.modalTitle = "Хэрэглэгчид хуваарилагдсан дуудлагууд";
      request({
        api: { method: "POST", url: "asset/openTicketsByUser" },
        data: {
          userId: e.userId,
          assetTypeId: this.filter.typeCur,
          breakDownDelayTypeId: this.filter.categoryCur,
          assetLocationId: this.filter.locationCur,
          page: 0,
          size: 10,
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.selectedUserTickets.info = e;
          this.selectedUserTickets.list = res.data.list;
          //console.log('selectedUserTickets=> ', res.data);
          this.selectedUserTickets.rdy = true;
          this.selectedUserTickets.modal = true;
        }
      });
    },
  },
};
</script>

<style>
#assetHomeModal___BV_modal_outer_ {
  z-index: 1034 !important;
}
</style>
